import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "overlay-folder" }
const _hoisted_2 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_overlay_panel = _resolveComponent("app-overlay-panel")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", { cardSelected: _ctx.isSelected }])
  }, [
    _createElementVNode("div", {
      ref: "targetRef",
      class: "icon",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCardOverlayPanel && _ctx.toggleCardOverlayPanel(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        size: "sm",
        icon: ['fas', 'ellipsis-v']
      })
    ], 512),
    (_ctx.targetRef)
      ? (_openBlock(), _createBlock(_component_app_overlay_panel, {
          key: 0,
          visible: _ctx.visible,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
          width: 150,
          target: _ctx.targetRef,
          position: {
        x: 'center',
        y: 'bottom',
      }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "overlay-folder-item",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteTemplate && _ctx.deleteTemplate(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  size: "sm",
                  icon: ['fas', 'fa-trash']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('delete')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible", "target"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "segments",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selected && _ctx.selected(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.card.segments, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: "segment",
          style: _normalizeStyle({ backgroundColor: item.color })
        }, null, 4))
      }), 128)),
      _createElementVNode("div", {
        class: "title",
        title: _ctx.card.name
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.card.name), 1)
      ], 8, _hoisted_2)
    ])
  ], 2))
}